import { ApiError } from "../api";

export function formatAuthError(err: unknown): string {
  if (err instanceof ApiError) {
    try {
      const parsed = JSON.parse(err.bodyText) as { error?: string };
      if (parsed.error) {
        return parsed.error;
      }
    } catch {
      /* ignore */
    }
    return err.message;
  }
  if (err instanceof Error) {
    return err.message;
  }
  return "Unknown error";
}
